'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lsamples_Persons$package$House$2(capacity) {
  this.sJ = 0;
  this.sJ = capacity;
}
export { $c_Lsamples_Persons$package$House$2 as $c_Lsamples_Persons$package$House$2 };
$p = $c_Lsamples_Persons$package$House$2.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_Persons$package$House$2;
/** @constructor */
function $h_Lsamples_Persons$package$House$2() {
}
export { $h_Lsamples_Persons$package$House$2 as $h_Lsamples_Persons$package$House$2 };
$h_Lsamples_Persons$package$House$2.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.m = (function() {
  var acc = (-889275714);
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, 69916416);
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, this.sJ);
  return $j_java$002elang$002e$002dObject.$m_sr_Statics$().an(acc, 1);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lsamples_Persons$package$House$2) && (this.sJ === x$0.sJ)));
});
$p.b = (function() {
  return $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().ah(this);
});
$p.n = (function() {
  return 1;
});
$p.o = (function() {
  return "House";
});
$p.g = (function(n) {
  if ((n === 0)) {
    return this.sJ;
  }
  throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__I__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), n);
});
function $isArrayOf_Lsamples_Persons$package$House$2(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ek)));
}
export { $isArrayOf_Lsamples_Persons$package$House$2 as $isArrayOf_Lsamples_Persons$package$House$2 };
var $d_Lsamples_Persons$package$House$2 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_Persons$package$House$2, "samples.Persons$package$House$2", ({
  ek: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lsamples_Persons$package$House$2 as $d_Lsamples_Persons$package$House$2 };
